import { mapActions } from 'vuex'

export default {
  data () {
    return {
    }
  },
  computed: {
  },
  created () {
  },
  mounted () {},
  methods: {
    ...mapActions('apScheduler', ['getSchedulerCount']),
    async getCountDataByTypeAndDay (day, type) {
      const resp = await this.getSchedulerCount({
        day: day,
        type: type
      })
      if (resp) {
        return resp
      } else {
        return {}
      }
    }
  }
}
